import React from 'react';
import cn from 'classnames';

var defaultColors = {"component":"skeleton__component_gvra9","animate":"skeleton__animate_gvra9","background":"skeleton__background_gvra9"};
require('./default.css')

var styles = {"component":"skeleton__component_5li1c","allowBackdropBlur":"skeleton__allowBackdropBlur_5li1c","borderRadius-0":"skeleton__borderRadius-0_5li1c","borderRadius-2":"skeleton__borderRadius-2_5li1c","borderRadius-4":"skeleton__borderRadius-4_5li1c","borderRadius-6":"skeleton__borderRadius-6_5li1c","borderRadius-10":"skeleton__borderRadius-10_5li1c","borderRadius-12":"skeleton__borderRadius-12_5li1c","borderRadius-16":"skeleton__borderRadius-16_5li1c","borderRadius-20":"skeleton__borderRadius-20_5li1c","borderRadius-24":"skeleton__borderRadius-24_5li1c","borderRadius-32":"skeleton__borderRadius-32_5li1c","borderRadius-36":"skeleton__borderRadius-36_5li1c","borderRadius-64":"skeleton__borderRadius-64_5li1c","borderRadius-pill":"skeleton__borderRadius-pill_5li1c","animate":"skeleton__animate_5li1c"};
require('./index.css')

var invertedColors = {"component":"skeleton__component_177q8","animate":"skeleton__animate_177q8","background-inverted":"skeleton__background-inverted_177q8"};
require('./inverted.css')

var colorStyles = {
    default: defaultColors,
    inverted: invertedColors,
};
var Skeleton = function (_a) {
    var _b;
    var visible = _a.visible, _c = _a.animate, animate = _c === void 0 ? true : _c, className = _a.className, dataTestId = _a.dataTestId, children = _a.children, style = _a.style, allowBackdropBlur = _a.allowBackdropBlur, _d = _a.colors, colors = _d === void 0 ? 'default' : _d, _e = _a.borderRadius, borderRadius = _e === void 0 ? 8 : _e;
    if (visible) {
        return (React.createElement("div", { className: cn(styles.component, colorStyles[colors].component, (_b = {},
                _b[styles.animate] = animate,
                _b[colorStyles[colors].animate] = animate,
                _b[styles.allowBackdropBlur] = allowBackdropBlur,
                _b[styles["borderRadius-".concat(borderRadius)]] = borderRadius !== 8,
                _b), className), style: style, "data-test-id": dataTestId }, children));
    }
    return (React.createElement("div", { "data-test-id": dataTestId, className: className, style: style }, children));
};

export { Skeleton };
